import { getSwingDetails } from 'src/Providers/Swing'
import { useQueryWithErrorHandling } from './useQueryWithErrorHandling'

type UseSwingDetailsParams = {
  swingId: string
  feFilterEnabled: boolean
}

export const useSwingDetails = ({ swingId, feFilterEnabled = true }: UseSwingDetailsParams) => {
  const query = useQueryWithErrorHandling(
    ['swingDetails', { swingId, feFilterEnabled }],
    () => getSwingDetails(swingId, feFilterEnabled),
    {
      staleTime: 5 * 60 * 1000,
    },
    'switches.swings.details.fetchError'
  )

  return {
    ...query,
    swingData: query.data,
  }
}
